var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  strokeWidth: 64,
  d: "M810.667 170.667H213.334c-47.128 0-85.333 38.205-85.333 85.333v597.333c0 47.13 38.205 85.333 85.333 85.333h597.333c47.13 0 85.333-38.204 85.333-85.333V256c0-47.128-38.204-85.333-85.333-85.333M682.667 85.333V256M341.333 85.333V256M128 426.667h768"
})));
export default SvgCalendar;